// extracted by css-extract-rspack-plugin
export default {"back-top":"back-top-bXa_3i","backTop":"back-top-bXa_3i"};